const CHUNK_RELOAD_GUARD_KEY = "km:chunk-reload-at";
const CHUNK_RELOAD_GUARD_MS = 30_000;

let installed = false;

function nowMs() {
  return Date.now();
}

function extractMessage(reason: unknown): string {
  if (typeof reason === "string") return reason;
  if (reason instanceof Error) return reason.message || "";
  if (typeof reason === "object" && reason !== null) {
    const msg = (reason as { message?: unknown }).message;
    if (typeof msg === "string") return msg;
    return String(reason);
  }
  return "";
}

export function isChunkLoadError(reason: unknown): boolean {
  const msg = extractMessage(reason);
  if (!msg) return false;
  return [
    /Importing a module script failed/i,
    /Failed to fetch dynamically imported module/i,
    /Loading chunk [\w-]+ failed/i,
    /ChunkLoadError/i,
    /is not a valid JavaScript MIME type/i,
  ].some((re) => re.test(msg));
}

function shouldReloadNow(): boolean {
  if (typeof window === "undefined") return false;
  const lastRaw = window.sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY);
  const last = Number(lastRaw ?? "0");
  const age = nowMs() - (Number.isFinite(last) ? last : 0);
  if (age >= 0 && age < CHUNK_RELOAD_GUARD_MS) return false;
  window.sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, String(nowMs()));
  return true;
}

export function clearChunkReloadGuard() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY);
}

export function reloadForChunkError(reason: unknown): boolean {
  if (!isChunkLoadError(reason)) return false;
  if (!shouldReloadNow()) return false;
  window.location.reload();
  return true;
}

export function installChunkErrorRecovery() {
  if (typeof window === "undefined" || installed) return;
  installed = true;

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (reloadForChunkError(event.reason)) {
        event.preventDefault();
      }
    },
    { capture: true },
  );

  window.addEventListener(
    "error",
    (event) => {
      const errEvent = event as ErrorEvent;
      if (reloadForChunkError(errEvent.error ?? errEvent.message)) {
        event.preventDefault();
        return;
      }

      const target = event.target;
      if (target instanceof HTMLScriptElement) {
        const src = target.src || "";
        if (src.includes("/assets/") && shouldReloadNow()) {
          window.location.reload();
        }
      }
    },
    { capture: true },
  );
}
